<template>
  <div>
    <b-modal
      size="lg"
      id="modal-edit-shipping"
      hide-footer
      hide-header
      centered
      v-model="showModal"
    >
      <div class="f-18 mb-3"><b>อัพเดตข้อมูลจัดส่ง</b></div>
      <b-row class="align-items-center" style="row-gap: 0.5rem">
        <b-col lg="3" md="4" sm="12"
          >ขนส่งที่ให้บริการ : <span class="text-danger">*</span>
        </b-col>
        <b-col lg="9" md="8" sm="12">
          <b-row>
            <b-col cols="6">
              <InputSelect
                name="chooseShippingName"
                valueField="id"
                textField="name"
                isRequired
                v-bind:options="shippingList"
                v-model="shippingSelect"
                @onDataChange="handleChangeShipping"
              />
              <small
                v-if="!shippingSelect && isShippingSelect"
                class="text-danger"
              >
                กรุณาเลือกการขนส่ง
              </small>
            </b-col>
            <b-col cols="6">
              <InputText
                placeholder="ระบุชื่อผู้ให้บริการ"
                type="text"
                @input="clearError('providerNameOtherError')"
                name="name"
                class="mb-0"
                isRequired
                :disabled="this.partnerOwnFleet.shippingId != 0"
                v-model="partnerOwnFleet.providerNameOther"
                textFloat=""
              />
              <small v-if="providerNameOtherError" class="text-danger">
                กรุณากรอกชื่อขนส่ง
              </small></b-col
            >
          </b-row>
        </b-col>

        <b-col lg="3" md="4" sm="12"
          >{{ $t("trackNo") }} : <span class="text-danger">*</span>
        </b-col>
        <b-col lg="9" md="8" sm="12">
          <InputText
            :placeholder="$t('trackNo')"
            textFloat=""
            @input="clearError('trackingNoError')"
            type="text"
            v-model="partnerOwnFleet.trackingNo"
            name="metadesc"
            isRequired
            class="mt-md-4"
          />
          <small v-if="trackingNoError" class="text-danger">
            กรุณากรอกชื่อขนส่ง
          </small>
        </b-col>
        <b-col class="offset-md-4  offset-lg-3 offset-0" lg="9" md="8" sm="12">
          <small class="text-danger">
            หมายเหตุ: สำหรับการจัดส่งโดยแบรนด์ จะไม่มีระบบติดตามพัสดุ
            สถานะของคำสั่งซื้อจะเป็นการจัดส่งสำเร็จเมื่อลูกค้ากดยืนยันการรับสินค้า</small
          ></b-col
        >
      </b-row>
      <div class="my-3">
        <div class="f-18 mb-3"><b>รายละเอียดการอัพเดท</b></div>
        <div class="w-100 mt-3 bg-white">
          <b-table
            striped
            responsive
            :items="dataList.partnerOwnFleetLog"
            :fields="fieldsTracking"
            show-empty
            empty-text="ไม่พบข้อมูล"
            class="table-list m-0"
          >
            <template v-slot:cell(createdTime)="data">
              <span>
                {{
                  new Date(data.item.createdTime)
                    | moment("DD MMMM YYYY (HH:mm)")
                }}</span
              >
            </template>
            <template v-slot:cell(trackingNo)="data">
              <span> {{ data.item.trackingNo }}</span>
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-flex">
        <b-button
          variant="outline-secondary"
          class="mr-auto min-25"
          @click="$bvModal.hide('modal-edit-shipping')"
          >ย้อนกลับ</b-button
        >
        <b-button variant="dark" class="ml-auto min-25" @click="updateShipping"
          >ยืนยัน</b-button
        >
      </div>
    </b-modal>
    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputText from "@/components/inputs/InputText";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import { required, integer, minLength } from "vuelidate/lib/validators";
export default {
  name: "Modal",
  components: {
    InputText,
    InputSelect,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
  },
  props: ["dataList"],
  data() {
    return {
      shippingList: [],
      showModal: false,
      itemsTracking: [],
      shippingSelect: "",
      isShippingSelect: false,
      providerNameOtherError: false,
      trackingNoError: false,
      modalMessage: "",
      partnerOwnFleet: {
        referenceTypeId: this.dataList.referenceTypeId,
        providerName: "",
        shippingId: "",
        trackingNo: "",
        providerNameOther: "",
      },
      fieldsTracking: [
        {
          key: "createdTime",
          label: "วันที่ทำรายการ",
          class: "w-100px",
        },
        {
          key: "providerName",
          label: "ขนส่ง",
          class: "w-100px",
        },
        {
          key: "trackingNo",
          label: "รายละเอียด",
          class: "w-100px",
        },
      ],
    };
  },
  validations: {
    partnerOwnFleet: {
      shippingId: { required },
      trackingNo: { required },
    },
  },
  mounted() {
    this.getShippingList();
  },
  created: async function() {},
  methods: {
    clearError(key) {
      this[key] = false;
    },
    handleChangeShipping(val) {
      this.isShippingSelect = false;
      this.partnerOwnFleet.providerNameOther = "";
      if (val == "other") return (this.partnerOwnFleet.shippingId = val);
      this.partnerOwnFleet.shippingId = val;
      this.partnerOwnFleet.providerName = this.shippingList.find(
        el => el.id == val
      ).name;
    },
    async updateShipping() {
      var error = false;
      if (!this.partnerOwnFleet.trackingNo) {
        this.trackingNoError = true;
        error = true;
      }
      if (
        !this.partnerOwnFleet.shippingId &&
        !this.partnerOwnFleet.providerNameOther
      ) {
        error = true;
        this.providerNameOtherError = true;
      } else if (
        !this.partnerOwnFleet.shippingId &&
        this.partnerOwnFleet.shippingId != 0
      ) {
        error = true;
        this.isShippingSelect = true;
      }
      console.log(error);
      if (error) return;
      this.$refs.modalLoading.show();
      this.partnerOwnFleet.referenceTypeId = this.dataList.referenceTypeId;
      this.partnerOwnFleet.providerName = this.partnerOwnFleet.providerNameOther;
      try {
        let data = await this.$callApi(
          "post",
          `${this.$baseUrl}/api/ownFleet/save`,
          null,
          this.$headers,
          { partnerOwnFleet: this.partnerOwnFleet }
        );
        this.modalMessage = data.message;
        if (data.result == 1) {
          this.$emit("getData");
          this.hide();
          this.$refs.modalLoading.hide();
          this.$refs.modalAlert.show();

          setTimeout(() => {
            this.$refs.modalAlert.hide();
          }, 3000);
        } else {
          this.$refs.modalLoading.hide();
          this.$refs.modalAlertError.show();
          setTimeout(() => {
            this.$refs.modalAlertError.hide();
          }, 3000);
        }
      } catch (error) {
        this.$refs.modalLoading.hide();
        this.$refs.modalAlertError.show();
        setTimeout(() => {
          this.$refs.modalAlertError.hide();
        }, 3000);
      }
    },
    async getShippingList() {
      let data = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/Shipping/List`,
        null,
        this.$headers,
        this.filter
      );

      if (data.result == 1) {
        this.shippingList = data.detail.dataList.filter(obj => obj.id != 15);

        this.shippingList.splice(0, 0, {
          id: "",
          name: "กรุณาเลือกการขนส่ง",
          disabled: true,
          selected: true,
        });
        this.shippingList.push({
          id: 0,
          name: "ผู้ให้บริการอื่นๆ",
        });
      }
    },
    show() {
      this.showModal = true;
      this.shippingSelect = this.dataList.shippingId;
      this.isShippingSelect = false;
      this.providerNameOtherError = false;
      this.trackingNoError = false;
      this.partnerOwnFleet = { ...this.dataList };
    },
    hide() {
      this.showModal = false;
    },
  },
};
</script>
<style lang="css">
.min-25 {
  min-width: 25%;
}
</style>
